import styled from 'styled-components';
import { SeatReservationStatus } from '@/apiModels/SeatReservation';
import theme from '@/data/theme';

const StyledBookingInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledSeatStatusButton = styled.button<{
  status: SeatReservationStatus;
  bookedBy?: string;
}>`
  padding: 0.625rem 1.25rem;
  border: none;
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-family: ${theme.fonts.primary};
  cursor: ${({ status, bookedBy }) => {
    if (status === SeatReservationStatus.BOOKED && bookedBy?.toLowerCase() === 'organizer') {
      return 'pointer';
    }
    if (status === SeatReservationStatus.BOOKED && bookedBy?.toLowerCase() === 'revel') {
      return 'not-allowed';
    }

    switch (status) {
      case SeatReservationStatus.BOOKED:
        return 'pointer';
      case SeatReservationStatus.COMPLETED:
        return 'pointer';
      case SeatReservationStatus.AVAILABLE:
        return 'pointer';
      case SeatReservationStatus.DISABLED:
        return 'pointer';
      case SeatReservationStatus.HOLD:
        return 'not-allowed';
      default:
        return '#7f8c8d';
    }
  }};

  font-size: 0.875rem;
  transition: background-color 0.3s ease;

  background-color: ${({ status, bookedBy }) => {
    if (status === SeatReservationStatus.BOOKED && bookedBy?.toLowerCase() === 'organizer') {
      return 'rgba(16, 185, 129, 0.2)';
    }

    switch (status) {
      case SeatReservationStatus.BOOKED:
        return 'rgba(239,68,68,0.30)';
      case SeatReservationStatus.DISABLED:
        return 'rgba(134, 92, 208, 0.3)';
      case SeatReservationStatus.COMPLETED:
        return '#2ecc71';
      case SeatReservationStatus.AVAILABLE:
        return 'rgba(134, 92, 208, 0.3)';
      case SeatReservationStatus.HOLD:
        return 'rgba(249,115,22,0.28)';
      default:
        return '#7f8c8d';
    }
  }};

  color: ${({ status, bookedBy }) => {
    if (status === SeatReservationStatus.BOOKED && bookedBy?.toLowerCase() === 'organizer') {
      return '#10B981';
    }

    switch (status) {
      case SeatReservationStatus.BOOKED:
        return '#EF4444';
      case SeatReservationStatus.DISABLED:
        return '#865CD0';
      case SeatReservationStatus.COMPLETED:
        return '';
      case SeatReservationStatus.HOLD:
        return '#F97316';
      case SeatReservationStatus.AVAILABLE:
        return '#865CD0';
      default:
        return '#7f8c8d';
    }
  }};
`;

const StyledBookingInformation = styled.div`
  p {
    color: #6b7280;
    font-size: 12px;
    line-height: 1.6;
    font-weight: 400;
  }

  strong {
    font-weight: normal;
  }

  br {
    display: none;
  }
`;

const StyledSubHeaderWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

const StyledInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const StyledBookingDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
  max-height: 240px;
  overflow-y: scroll;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const BookingInforTableDetailValue = styled.div`
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
`;

export {
  StyledBookingInformationWrapper,
  StyledBookingInformation,
  StyledSeatStatusButton,
  StyledInformationWrapper,
  StyledBookingDetailsWrapper,
  StyledSubHeaderWrapper,
  BookingInforTableDetailValue,
  StyledColumn,
};
